/**
 * Utility for merging Tailwind CSS classes
 * Combines clsx (conditional classes) with tailwind-merge (deduplication)
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
